import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=fbb729de"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateForm.vue?vue&type=style&index=0&id=fbb729de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports